import React, { useEffect, useRef } from 'react'
import styles from './LocationSection.module.css'
import mapImg from '../../assets/everett-map.png'

const categories = [
    {
        label: 'Malls',
        items: [
            { name: 'Tribeca Highstreet', dist: '3.7 KM' },
            { name: 'Amanora Mall', dist: '8.5 KM' },
            { name: 'Kumar Pacific', dist: '2.5 KM' },
            { name: 'Phoenix Marketcity', dist: '11.4 KM' },
            { name: 'Seasons Mall', dist: '8.5 KM' },
            { name: 'KOPA Mall', dist: '9.7 KM' },
        ],
    },
    {
        label: 'Hospitals',
        items: [
            { name: 'Ruby Hall Clinic', dist: '2.4 KM' },
            { name: 'Command Hospital', dist: '1.2 KM' },
            { name: 'Motherhood Hospital', dist: '0.8 KM' },
            { name: 'Noble Hospital', dist: '6.7 KM' },
            { name: 'Inamdar Hospital', dist: '3.1 KM' },
        ],
    },
    {
        label: 'Schools & Colleges',
        items: [
            { name: 'Bishops School', dist: '3.3 KM' },
            { name: 'Vibgyor High', dist: '4.6 KM' },
            { name: 'EURO School', dist: '5.4 KM' },
            { name: 'Fergusson College', dist: '8.5 KM' },
            { name: "St. Mary's School", dist: '3.6 KM' },
        ],
    },
    {
        label: 'Commercial Hubs',
        items: [
            { name: 'Trump World Center (TWC)', dist: '13.4 KM' },
            { name: '99 Avenue', dist: '0.35 KM' },
            { name: 'Solitaire Business Hub', dist: '2.7 KM' },
            { name: 'Konark Business Hub', dist: '2.8 KM' },
        ],
    },
    {
        label: 'Transit Hubs',
        items: [
            { name: 'Pune Airport', dist: '12.4 KM' },
            { name: 'Swargate Metro Station', dist: '4.7 KM' },
            { name: 'Market Yard Metro Station', dist: '3.5 KM' },
            { name: 'Pune Railway Station', dist: '6.6 KM' },
        ],
    },
    {
        label: 'Temples',
        items: [
            { name: 'Vasupujya Swami Jain Mandir', dist: '1.3 KM' },
            { name: 'Shri Mahalaxmi Temple', dist: '4.6 KM' },
            { name: 'ISKCON NVCC', dist: '6.0 KM' },
            { name: 'Shree Vardhaman Jain Temple', dist: '2.1 KM' },
        ],
    },
    {
        label: 'Five Star Properties',
        items: [
            { name: 'Sheraton Grand', dist: '6.6 KM' },
            { name: 'The Westin Pune', dist: '9.7 KM' },
            { name: 'Conrad Hotel', dist: '7.4 KM' },
        ],
    },
]

const LocationSection = () => {
    const sectionRef = useRef(null)

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(styles.visible)
                    }
                })
            },
            { threshold: 0.1 }
        )

        const els = sectionRef.current?.querySelectorAll('[data-animate]')
        els?.forEach((el) => observer.observe(el))
        return () => observer.disconnect()
    }, [])

    return (
        <section className={styles.section} ref={sectionRef}>

            {/* ── Header ── */}
            <div className={styles.header} data-animate>
                <span className={styles.eyebrow}>
                    <span className={styles.eyebrowLine}></span>
                    LOCATION
                    <span className={styles.eyebrowLine}></span>
                </span>
                <h2 className={styles.heading}>
                    Lullanagar's <em>Finest Address</em>
                </h2>
                <p className={styles.subheading}>
                    Set in the serene heart of Lullanagar, right near Command Hospital,
                    this address captures the essence of exclusivity and convenience.
                    Surrounded by lush tranquillity and urban sophistication, it stands
                    poised to become a landmark of stature — a place where refined
                    living finds its most distinguished form.
                </p>
            </div>

            {/* ── Main Grid ── */}
            <div className={styles.grid}>

                {/* Left: Map */}
                <div className={styles.mapWrapper} data-animate>
                    <img
                        src={mapImg}
                        alt="Location map of The Everett, Lullanagar"
                        className={styles.mapImg}
                    />
                    <div className={styles.mapBadge}>
                        <span className={styles.mapBadgeDot}></span>
                        THE EVERETT
                        <span className={styles.mapBadgeSub}>Lullanagar, Pune</span>
                    </div>
                </div>

                {/* Right: Categories */}
                <div className={styles.rightPanel} data-animate>
                    {categories.map((cat, i) => (
                        <div key={i} className={styles.category}>
                            <p className={styles.catLabel}>{cat.label}</p>
                            <ul className={styles.catList}>
                                {cat.items.map((item, j) => (
                                    <li key={j} className={styles.catItem}>
                                        <span className={styles.catName}>{item.name}</span>
                                        <span className={styles.catDots}></span>
                                        <span className={styles.catDist}>{item.dist}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}

                    <div className={styles.addressCard}>
                        <p className={styles.addressLabel}>ADDRESS</p>
                        <p className={styles.addressText}>
                            The Everett, Lullanagar,<br />
                            Pune, Maharashtra
                        </p>
                        <div className={styles.addressDivider}></div>
                        <p className={styles.addressNote}>
                            Adjacent to Command Hospital, one of Pune's most prestigious landmarks.
                        </p>
                    </div>
                </div>

            </div>

        </section>
    )
}

export default LocationSection